<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
          <el-form size="small" inline label-width="100px">
            <el-form-item label="订单状态：">
              <el-radio-group v-model="tableFrom.status" type="button" @change="getList(1)">
                <el-radio-button label="">全部 {{ '(' +orderChartType.all?orderChartType.all:0 + ')' }}</el-radio-button>
                <el-radio-button
                  label="0"
                >未支付 {{ '(' +orderChartType.noPayAppraisal?orderChartType.noPayAppraisal:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="1"
                >已支付 {{ '(' +orderChartType.yesPayAppraisal?orderChartType.yesPayAppraisal:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="4"
                >待鉴定 {{ '(' +orderChartType.deliveryAppraisal?orderChartType.deliveryAppraisal:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="5"
                >已鉴定 {{ '(' +orderChartType.yesAppraisal?orderChartType.yesAppraisal:0+ ')' }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="鉴别状态：">
              <el-radio-group v-model="tableFrom.product_status" type="button" @change="getList(1)">
                <el-radio-button label="">全部</el-radio-button>
                <el-radio-button
                  label="1"
                >真 {{ '(' +orderChartType.realAppraisal?orderChartType.realAppraisal:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="2"
                >假 {{ '(' +orderChartType.failAppraisal?orderChartType.failAppraisal:0+ ')' }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间选择：" class="width100">
              <el-radio-group
                v-model="tableFrom.date"
                type="button"
                class="mr20"
                size="small"
                @change="selectChange(tableFrom.date)"
              >
                <el-radio-button
                  v-for="(item,i) in fromList.fromTxt"
                  :key="i"
                  :label="item.val"
                >{{ item.text }}</el-radio-button>
              </el-radio-group>
              <el-date-picker
                v-model="timeVal"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                size="small"
                type="daterange"
                placement="bottom-end"
                placeholder="自定义时间"
                style="width: 250px;"
                @change="onchangeTime"
              />
            </el-form-item>
            <el-form-item label="分类名称：" style="display: inline-block;">
              <el-cascader
                v-model="tableFrom.category_id"
                class="selWidth"
                :options="appraisalCateList"
                :props="props"
                clearable
                @change="getList(1)"
              />
            </el-form-item>
            <el-form-item label="关键字：" class="width100" style="display: inline-block;">
              <el-input
                v-model="tableFrom.keywords"
                @keyup.enter.native="getList(1)"
                placeholder="请输入订单号"
                class="selWidth"
                size="small"
              >
                <el-button slot="append" icon="el-icon-search" size="small" class="el-button-solt" @click="getList(1)" />
              </el-input>
            </el-form-item>
            <el-form-item label="用户信息：" class="width100" style="display: inline-block;">
              <el-input
                v-model="tableFrom.username"
                @keyup.enter.native="getList(1)"
                placeholder="请输入用户昵称/手机号"
                class="selWidth"
                size="small"
              >
                <el-button slot="append" icon="el-icon-search" size="small" class="el-button-solt" @click="getList(1)" />
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <el-table
        v-loading="listLoading"
        :data="tableData.data"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          label="ID"
          prop="appraisal_order_id"
          min-width="50" />
        <el-table-column
          label="订单号"
          prop="order_sn"
          min-width="150" />
        <el-table-column
          label="用户昵称"
          prop="user.nickname"
          min-width="100" />
        <el-table-column
          label="类型"
          prop="appraisal_type_text"
          min-width="100" />
        <el-table-column
          label="品类"
          prop="cateOne.cate_name"
          min-width="100" />
        <el-table-column
          label="品牌"
          prop="cateTwo.cate_name"
          min-width="100" />
        <el-table-column
          label="系列"
          prop="cateThree.cate_name"
          min-width="100" />
        <el-table-column
          label="支付金额"
          prop="pay_price"
          min-width="100" />
        <el-table-column
          label="状态"
          prop="status_text"
          min-width="100" />
        <el-table-column
          label="鉴定状态"
          prop="product_status_text"
          min-width="100" />
        <el-table-column
          label="创建时间"
          prop="create_time"
          min-width="160" />
        <el-table-column label="操作" min-width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="onDetail(scope.row.appraisal_order_id)">详情</el-button>
            <el-button type="text" size="small" v-if = 'scope.row.status != 5' @click="onEdit(scope.row.appraisal_order_id)">编辑状态</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row.appraisal_order_id, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :page-sizes="[20, 40, 60, 80]"
          :page-size="tableFrom.limit"
          :current-page="tableFrom.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </el-card>
    <el-dialog v-if="dialogVisible" title='详情' :visible.sync="dialogVisible" width="700px">
      <div v-loading="loading" class="divBox">
        <el-card class="box-card">
          <el-form ref="formData"   label-width="120px" class="demo-ruleForm">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="订单ID：">
                  <div>{{formData.appraisal_order_id}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="订单号：">
                  <div>{{formData.order_sn}}</div>
                </el-form-item>
              </el-col>
              <el-form-item label='图片：'>
                <div v-for="(item, index) in formData.slide_image" :key="index" style="display: inline-block; margin: 0 10px 10px 0">
                  <el-image
                    style="width: 80px; height: 80px"
                    :src="item || ''"
                    :preview-src-list="[item?item:'']"
                  />
                </div>
              </el-form-item>
              <el-col :span="12">
                <el-form-item label="描述：">
                  <div>{{formData.product_content}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="品类：" v-if = 'formData.cate'>
                  <div>{{formData.cate.cate_name}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="品牌：" v-if = 'formData.brand'>
                  <div>{{formData.brand.brand_name}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="用户：" v-if = 'formData.user'>
                  <span>{{formData.user.nickname}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="用户ID：" v-if = 'formData.user'>
                  <span>{{formData.user.uid}}</span>
                </el-form-item>
              </el-col>
              <el-form-item label="状态：">
                <span>{{formData.status_text}}</span>
              </el-form-item>
              <el-col :span="12">
                <el-form-item label="物品状态：" v-if="formData.status >= 5">
                  <span>{{formData.product_status_text}}</span>
                </el-form-item>
              </el-col>
              <el-form-item label="真假说明：" v-if="formData.status >= 5">
                <span>{{formData.product_status_desc}}</span>
              </el-form-item>
              <el-form-item label="创建时间：">
                <span>{{formData.create_time}}</span>
              </el-form-item>
            </el-row>
          </el-form>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { roterPre } from '@/settings'
import {
  appraisalBrandDeleteApi,
  appraisalBrandListApi,
  appraisalBrandSelectListApi,
  appraisalCategoryMenuListApi,
  appraisalCateSelectListApi,
  appraisalEntityCardListApi,
  appraisalEntityChartListApi,
  appraisalEntityListApi,
  appraisalEntityOrderDeleteApi,
  appraisalOnlineChartListApi,
  appraisalOrderEntityAuditApi,
  appraisalOrderEntityDetailApi,
  appraisalOrderEntityUpdateApi,
  appraisalOrderOnlineUpdateApi,
} from "@/api/appraisal";
import {fromList} from "@/libs/constants";
import {communityAuditApi, communityDetailApi, communityUpdateApi} from "@/api/community";
export default {
  name: 'appraisalOnlineOrder',
  components: {},
  data() {
    return {
      props: { checkStrictly: true, emitPath: false},
      moren: require("@/assets/images/f.png"),
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      roterPre: roterPre,
      tableFrom: {
        page: 1,
        limit: 20,
      },
      orderChartType: {},
      fromList: fromList,
      cardLists: [],
      timeVal: [],
      dialogVisible:false,
      loading: false,
      formData: {},
      ruleForm:{},
      appraisal_order_id:'',
      appraisalCateList:[],
    }
  },
  mounted() {
    this.getList(1)
    this.headerList();
    this.appraisalMenuCategory()
  },
  methods: {
    appraisalMenuCategory() {
      appraisalCategoryMenuListApi(3)
        .then((res) => {
          console.log(res.data)
          this.appraisalCateList = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    // 详情
    onDetail(id) {
      this.appraisal_order_id = id;
      this.dialogVisible = true;
      this.isExamine = false;
      appraisalOrderEntityDetailApi(id).then((res) => {
        this.formData = res.data
      }).catch(({ message }) => {
        this.$message.error(message)
      })
    },
    // 编辑
    onEdit(id) {
      this.$modalForm(appraisalOrderOnlineUpdateApi(id)).then(() => this.getList(''))
    },
    headerList() {
      appraisalOnlineChartListApi()
        .then((res) => {
          this.orderChartType = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    getCateSelect()
    {
      appraisalCateSelectListApi()
        .then((res) => {
          this.cateSelect = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    getBrandSelect()
    {
      appraisalBrandSelectListApi()
        .then((res) => {
          this.brandSelect = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    // 选择时间
    selectChange(tab) {
      this.tableFrom.date = tab;
      this.tableFrom.page = 1;
      this.timeVal = [];
      this.getList(1);
    },
    // 具体日期
    onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.date = e ? this.timeVal.join("-") : "";
      this.tableFrom.page = 1;
      this.getList(1);
    },
    // 列表
    getList(num) {
      this.listLoading = true
      this.tableFrom.page = num ? num : this.tableFrom.page
      this.tableFrom.appraisal_type_list = 2;
      appraisalEntityListApi(this.tableFrom).then(res => {
        this.tableData.data = res.data.list
        this.tableData.total = res.data.count
        this.listLoading = false
      }).catch(res => {
        this.listLoading = false
        this.$message.error(res.message)
      })
    },
    pageChange(page) {
      this.tableFrom.page = page
      this.getList('')
    },
    handleSizeChange(val) {
      this.tableFrom.limit = val
      this.getList('')
    },
    // 删除
    handleDelete(id, idx) {
      this.$modalSure('确定删除该品牌吗？').then(() => {
        appraisalEntityOrderDeleteApi(id).then(({ message }) => {
          this.$message.success(message)
          this.getList('')
        }).catch(({ message }) => {
          this.$message.error(message)
        })
      })
    },
  }
}
</script>

<style scoped lang="scss">
.box-container {
  overflow: hidden;
}
.box-container .list {
  float: left;
  line-height: 40px;
}
.box-container .sp {
  width: 50%;
}
.box-container .sp3 {
  width: 33.3333%;
}
.box-container .sp100 {
  width: 100%;
}
.box-container .list .name {
  display: inline-block;
  width: 150px;
  text-align: right;
  color: #606266;
}
.box-container .list.image {
  margin-bottom: 40px;
}
.box-container .list.image img {
  position: relative;
  top: 40px;
}
/deep/.el-form-item__content .el-rate{
  position: relative;
  top: 8px;
}
</style>
